"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_CUS_PF_DELETE = exports.API_CUS_PF_UPDATE_TOGGLE = exports.API_CUS_PF_DETAIL = exports.API_CUS_PF_FETCH = exports.API_CUS_PF_LIST_PUBLIC = exports.API_CUS_PF_LIST = exports.API_CUS_PF_SAVE = void 0;
var API_CUS_PF_SAVE;
(function (API_CUS_PF_SAVE) {
    API_CUS_PF_SAVE.PATH = '/cus-pf/save';
    API_CUS_PF_SAVE.PURPOSE = '단체복 포트폴리오 저장';
})(API_CUS_PF_SAVE = exports.API_CUS_PF_SAVE || (exports.API_CUS_PF_SAVE = {}));
var API_CUS_PF_LIST;
(function (API_CUS_PF_LIST) {
    API_CUS_PF_LIST.PATH = '/cus-pf/list';
    API_CUS_PF_LIST.PURPOSE = '단체복 포트폴리오 목록조회';
})(API_CUS_PF_LIST = exports.API_CUS_PF_LIST || (exports.API_CUS_PF_LIST = {}));
var API_CUS_PF_LIST_PUBLIC;
(function (API_CUS_PF_LIST_PUBLIC) {
    API_CUS_PF_LIST_PUBLIC.PATH = '/cus-pf/list-public';
    API_CUS_PF_LIST_PUBLIC.PURPOSE = '단체복 포트폴리오 목록조회';
})(API_CUS_PF_LIST_PUBLIC = exports.API_CUS_PF_LIST_PUBLIC || (exports.API_CUS_PF_LIST_PUBLIC = {}));
var API_CUS_PF_FETCH;
(function (API_CUS_PF_FETCH) {
    API_CUS_PF_FETCH.PATH = '/cus-pf/fetch';
    API_CUS_PF_FETCH.PURPOSE = '단체복 포트폴리오 상세조회';
})(API_CUS_PF_FETCH = exports.API_CUS_PF_FETCH || (exports.API_CUS_PF_FETCH = {}));
var API_CUS_PF_DETAIL;
(function (API_CUS_PF_DETAIL) {
    API_CUS_PF_DETAIL.PATH = '/cus-pf/detail';
    API_CUS_PF_DETAIL.PURPOSE = '단체복 포트폴리오 상세조회 서비스용';
})(API_CUS_PF_DETAIL = exports.API_CUS_PF_DETAIL || (exports.API_CUS_PF_DETAIL = {}));
var API_CUS_PF_UPDATE_TOGGLE;
(function (API_CUS_PF_UPDATE_TOGGLE) {
    API_CUS_PF_UPDATE_TOGGLE.PATH = '/cus-pf/update-toggle';
    API_CUS_PF_UPDATE_TOGGLE.PURPOSE = '단체복 포트폴리오 토글식 업데이트';
})(API_CUS_PF_UPDATE_TOGGLE = exports.API_CUS_PF_UPDATE_TOGGLE || (exports.API_CUS_PF_UPDATE_TOGGLE = {}));
var API_CUS_PF_DELETE;
(function (API_CUS_PF_DELETE) {
    API_CUS_PF_DELETE.PATH = '/cus-pf/delete';
    API_CUS_PF_DELETE.PURPOSE = '단체복 포트폴리오 삭제';
})(API_CUS_PF_DELETE = exports.API_CUS_PF_DELETE || (exports.API_CUS_PF_DELETE = {}));
//# sourceMappingURL=api-cus-pf.js.map